import { createSelector } from 'reselect';
import _get from 'lodash/get';

import { createOption } from 'react-redux-app/lib/modules/form/utils/multiSelect';


const getInitData = state => _get(state, 'init.initData');
export const getAllCountries = state => _get(getInitData(state), 'allCountries');
export const getAllCountriesOptions = createSelector(
  getAllCountries,
  allCountries => allCountries.map(({ code, name }) => createOption(name, code))
);
export const getAvailableAffiliateProgramTypes = state => (
  _get(getInitData(state), 'availableAffiliateProgramTypes')
);
export const getRivcashCloneId = state => _get(getInitData(state), 'siteId');
export const getReCaptchaKey = state => _get(getInitData(state), 'reCaptchaKey');
export const getPayoutLimits = state => _get(getInitData(state), 'payoutLimits');

export const getInitDataError = state => _get(getInitData(state), 'error');
